module.exports = __webpack_public_path__ + "roboto-v15-latin-700.7f57c4c0f3b44acbe338.svg";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/layout/fonts/roboto-v15-latin-700.svg
// module id = ../../../../../src/assets/layout/fonts/roboto-v15-latin-700.svg
// module chunks = 2